import React from 'react';
import PropTypes from 'prop-types';

import PackageItem from './PackageItem';

import styles from './index.scss';

export const VerticalFeaturePackageList = ({ featurePackages, trialInfo }) => (
  <div className={styles.packageList}>
    {featurePackages.map((featurePackage) => (
      <div key={featurePackage.id} className={styles.item}>
        <PackageItem
          packageKey={featurePackage.key}
          {...featurePackage}
          trialInfo={trialInfo}
        />
      </div>
    ))}
  </div>
);

VerticalFeaturePackageList.propTypes = {
  featurePackages: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number.isRequired,
      title: PropTypes.string.isRequired,
      description: PropTypes.string.isRequired,
      detailedDescription: PropTypes.string.isRequired,
      features: PropTypes.arrayOf(
        PropTypes.shape({
          name: PropTypes.string.isRequired,
          title: PropTypes.string.isRequired,
          description: PropTypes.string.isRequired
        })
      ).isRequired
    })
  ).isRequired,
  trialInfo: PropTypes.shape({})
};

VerticalFeaturePackageList.defaultProps = {
  trialInfo: null
};

export default VerticalFeaturePackageList;
